import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Guard that only allows workspace owners (workspace_role === "owner").
 * Members who navigate directly to an owner-only URL are sent back to /app.
 */
export default function RequireOwner({ children }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;
  if (user.workspace_role !== "owner") return <Navigate to="/app" replace />;

  return children;
}
